<template>
  <el-row>
    <div class="row">
      <w-operation-state-info :params="params" :rsc-info="operationStateParams" :active="active"></w-operation-state-info>
      <el-col :md="12" :lg="12">
        <w-perf-widget :show-change-btn="false">
          <span slot="perfHeader">구성 정보</span>
          <div slot="perfBody">
            <el-col :md="24" :lg="12">
              <table class="list-none-border">
                <tr>
                  <th>장비명</th>
                  <td>{{getEmptyText(configInfoData.objName)}}</td>
                </tr>
                <tr>
                  <th>IP</th>
                  <td>{{getEmptyText(configInfoData.ipaddress)}}</td>
                </tr>
                <tr>
                  <th>가상화 벤더</th>
                  <td>{{getEmptyText(configInfoData.basicinfoSubname)}}</td>
                </tr>
                <tr>
                  <th>장비 종류</th>
                  <td>{{getEmptyText(configInfoData.objtypeName)}}</td>
                </tr>
              </table>
            </el-col>
            <el-col :md="24" :lg="12">
              <table class="list-none-border">
                <tr>
                  <th>가상시스템 수</th>
                  <td>{{getEmptyText(configInfoData['VHO_COMMON/VM_COUNT'])}}</td>
                </tr>
                <tr>
                  <th>관리자 (정/부)</th>
                  <td>{{ getEmptyText(configInfoData.objManagerIdMajor) }} / {{ getEmptyText(configInfoData.objManagerIdMinor) }}</td>
                </tr>
              </table>
            </el-col>
          </div>
          <div slot="perfFooter">
            <span>최근 변경시각: {{ configInfoData.checkDatetimeLabel }} </span>
          </div>
        </w-perf-widget>
      </el-col>
      <el-col :md="12" :lg="12">
        <w-event-info-widget :event-info-data="eventInfoData"></w-event-info-widget>
      </el-col>
    </div>
  </el-row>
</template>

<script>
import { convertValuByUnit } from '@/utils/number';
import { mapGetters } from 'vuex';
import { isEmpty, clone, isNil } from 'lodash';
import { EMPTY_TEXT } from '@/utils/string';
import moment from 'moment';
import summaryApi from '@/api/performance/summary/summary-info';
import perfApi from '@/api/virtual/performance/config';
import { getIntervalDatetimeParams } from '@/utils/date';
import WPerfWidget from '../../components/PerfWidget';
import WOperationStateInfo from '../../components/OperationStateInfo';
import WEventInfoWidget from '../../components/EventInfoWidget';
import WSummaryLineChart from '../../components/SummaryLineChart';

export default {
  name: 'WKvmHostView',
  components: {
    WEventInfoWidget,
    WSummaryLineChart,
    WOperationStateInfo,
    WPerfWidget,
  },
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    selectedNode: {
      handler(node) {
        if (isEmpty(node)) {
          return;
        }
        this.loadData();
      },
      immediate: true,
    },
    active: {
      handler() {
        this.loadData();
      },
    },
  },
  data() {
    return {
      operationStateParams: {
        rsctypeId: 'VHO_RUNNINGSTATUS',
        rscId: 'ALIVE',
        rscKey: '_',
      },
      params: {
        managetypeId: 'VMS',
        managetypeKey: 'VHO',
      },
      configInfoData: {
        periodVhoBootTime: '',
        checkDatetimeLabel: '',
      },
      eventInfoData: {},
    };
  },
  methods: {
    getIntervalDatetimeParams,
    loadData() {
      if (this.active) {
        const startDatetime = this.getIntervalDatetimeParams(new Date(), 'hour', 12);
        Object.assign(this.params, {
          objId: this.selectedNode.obj.objId,
          startDatetime,
        });
        this.loadConfInfoView();
        this.loadEventInfo();
      }
    },
    loadConfInfoView() {
      perfApi.getNodeConfigInfoForObjtype({
        objId: this.selectedNode.obj.objId,
        objtypeId: 'VHO',
      }).then((response) => {
        if (response.data.success && response.data.data.length > 0) {
          this.configInfoData = response.data.data[0];
          this.configInfoData.checkDatetimeLabel = !isNil(this.configInfoData.checkDatetime) ? moment(this.configInfoData.checkDatetime).format('YYYY년 MM월 DD일 HH:mm:ss') : EMPTY_TEXT;
        }
      });
    },
    loadEventInfo() {
      const params = clone(this.params);
      params.endDatetime = new Date().getTime();

      summaryApi.getSummaryEventInfo(params).then((response) => {
        if (response.data.success) {
          this.eventInfoData = response.data.data;
        }
      });
    },
    getEmptyText(value) {
      if (!isNil(value) && value !== '') {
        return value;
      }
      return EMPTY_TEXT;
    },
    convertValuByUnit,
  },
};
</script>

<style scope>
  .list-none-border th {
    width: 142px;
  }
</style>



// WEBPACK FOOTER //
// src/views/performance/node/summary/virtual/components/KvmHostView.vue